// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* Design Tokens - Spacing & Sizing */
/* All --vnsc-space-*, --vnsc-radius-*, --vnsc-size-* tokens */

/* H0.8: \`.vnsc-root\` — the document-root selector never matches inside the
   widget's Shadow DOM (useShadowDOM defaults on), so tokens resolved to "". */
.vnsc-root {
  /* Base spacing unit: 4px */
  --vnsc-space-0: 0;
  --vnsc-space-1: 4px;   /* xs */
  --vnsc-space-2: 8px;   /* sm */
  --vnsc-space-3: 12px;  /* md-sm */
  --vnsc-space-4: 16px;  /* md */
  --vnsc-space-5: 20px;  /* md-lg */
  --vnsc-space-6: 24px;  /* lg */
  --vnsc-space-8: 32px;  /* xl */
  --vnsc-space-10: 40px; /* 2xl */
  --vnsc-space-12: 48px; /* 3xl */
  --vnsc-space-16: 64px; /* 4xl */

  /* Semantic spacing aliases */
  --vnsc-space-xs: 4px;
  --vnsc-space-sm: 8px;
  --vnsc-space-md: 16px;
  --vnsc-space-lg: 24px;
  --vnsc-space-xl: 32px;
  --vnsc-space-2xl: 40px;
  --vnsc-space-3xl: 48px;

  /* Component-specific spacing */
  --vnsc-space-toolbar-gap: 8px;
  --vnsc-space-toolbar-padding: 8px;
  --vnsc-space-panel-padding: 16px;
  --vnsc-space-modal-padding: 24px;
  --vnsc-space-drawing-gap: 4px;
  --vnsc-space-dock-padding: 12px;
  --vnsc-space-splitter-size: 4px;
  --vnsc-space-header-height: 36px;
  --vnsc-space-footer-height: 28px;
  --vnsc-space-panel-height: 300px;

  /* Border Radius */
  --vnsc-radius-none: 0;
  --vnsc-radius-xs: 2px;
  --vnsc-radius-sm: 4px;
  --vnsc-radius-md: 6px;
  --vnsc-radius-lg: 8px;
  --vnsc-radius-xl: 12px;
  --vnsc-radius-2xl: 16px;
  --vnsc-radius-full: 9999px;

  /* Semantic radius aliases */
  --vnsc-radius-button: 4px;
  --vnsc-radius-input: 4px;
  --vnsc-radius-card: 8px;
  --vnsc-radius-modal: 12px;
  --vnsc-radius-popover: 8px;
  --vnsc-radius-tooltip: 6px;

  /* Sizing */
  --vnsc-size-xs: 16px;
  --vnsc-size-sm: 24px;
  --vnsc-size-md: 32px;
  --vnsc-size-lg: 40px;
  --vnsc-size-xl: 48px;
  --vnsc-size-2xl: 56px;
  --vnsc-size-3xl: 64px;

  /* Icon sizes */
  --vnsc-icon-xs: 12px;
  --vnsc-icon-sm: 16px;
  --vnsc-icon-md: 20px;
  --vnsc-icon-lg: 24px;
  --vnsc-icon-xl: 28px;

  /* Button sizes */
  --vnsc-btn-height-sm: 24px;
  --vnsc-btn-height-md: 32px;
  --vnsc-btn-height-lg: 40px;
  --vnsc-btn-padding-x-sm: 8px;
  --vnsc-btn-padding-x-md: 12px;
  --vnsc-btn-padding-x-lg: 16px;

  /* Input sizes */
  --vnsc-input-height-sm: 24px;
  --vnsc-input-height-md: 32px;
  --vnsc-input-height-lg: 40px;
  --vnsc-input-padding-x: 10px;

  /* Chart-specific sizes */
  --vnsc-chart-margin-top: 8px;
  --vnsc-chart-margin-right: 12px;
  --vnsc-chart-margin-bottom: 32px;
  --vnsc-chart-margin-left: 12px;
  --vnsc-pane-min-height: 60px;
  --vnsc-pane-handle-size: 4px;
  --vnsc-tooltip-padding: 8px 12px;
  --vnsc-tooltip-gap: 4px;
}`, "",{"version":3,"sources":["webpack://./src/widget/styles/tokens/spacing.css"],"names":[],"mappings":"AAAA,qCAAqC;AACrC,8DAA8D;;AAE9D;8EAC8E;AAC9E;EACE,2BAA2B;EAC3B,iBAAiB;EACjB,mBAAmB,IAAI,OAAO;EAC9B,mBAAmB,IAAI,OAAO;EAC9B,oBAAoB,GAAG,UAAU;EACjC,oBAAoB,GAAG,OAAO;EAC9B,oBAAoB,GAAG,UAAU;EACjC,oBAAoB,GAAG,OAAO;EAC9B,oBAAoB,GAAG,OAAO;EAC9B,qBAAqB,EAAE,QAAQ;EAC/B,qBAAqB,EAAE,QAAQ;EAC/B,qBAAqB,EAAE,QAAQ;;EAE/B,6BAA6B;EAC7B,oBAAoB;EACpB,oBAAoB;EACpB,qBAAqB;EACrB,qBAAqB;EACrB,qBAAqB;EACrB,sBAAsB;EACtB,sBAAsB;;EAEtB,+BAA+B;EAC/B,6BAA6B;EAC7B,iCAAiC;EACjC,gCAAgC;EAChC,gCAAgC;EAChC,6BAA6B;EAC7B,+BAA+B;EAC/B,+BAA+B;EAC/B,gCAAgC;EAChC,gCAAgC;EAChC,gCAAgC;;EAEhC,kBAAkB;EAClB,qBAAqB;EACrB,qBAAqB;EACrB,qBAAqB;EACrB,qBAAqB;EACrB,qBAAqB;EACrB,sBAAsB;EACtB,uBAAuB;EACvB,0BAA0B;;EAE1B,4BAA4B;EAC5B,yBAAyB;EACzB,wBAAwB;EACxB,uBAAuB;EACvB,yBAAyB;EACzB,0BAA0B;EAC1B,0BAA0B;;EAE1B,WAAW;EACX,oBAAoB;EACpB,oBAAoB;EACpB,oBAAoB;EACpB,oBAAoB;EACpB,oBAAoB;EACpB,qBAAqB;EACrB,qBAAqB;;EAErB,eAAe;EACf,oBAAoB;EACpB,oBAAoB;EACpB,oBAAoB;EACpB,oBAAoB;EACpB,oBAAoB;;EAEpB,iBAAiB;EACjB,0BAA0B;EAC1B,0BAA0B;EAC1B,0BAA0B;EAC1B,4BAA4B;EAC5B,6BAA6B;EAC7B,6BAA6B;;EAE7B,gBAAgB;EAChB,4BAA4B;EAC5B,4BAA4B;EAC5B,4BAA4B;EAC5B,4BAA4B;;EAE5B,yBAAyB;EACzB,4BAA4B;EAC5B,+BAA+B;EAC/B,gCAAgC;EAChC,8BAA8B;EAC9B,4BAA4B;EAC5B,4BAA4B;EAC5B,gCAAgC;EAChC,uBAAuB;AACzB","sourcesContent":["/* Design Tokens - Spacing & Sizing */\r\n/* All --vnsc-space-*, --vnsc-radius-*, --vnsc-size-* tokens */\r\n\r\n/* H0.8: `.vnsc-root` — the document-root selector never matches inside the\r\n   widget's Shadow DOM (useShadowDOM defaults on), so tokens resolved to \"\". */\r\n.vnsc-root {\r\n  /* Base spacing unit: 4px */\r\n  --vnsc-space-0: 0;\r\n  --vnsc-space-1: 4px;   /* xs */\r\n  --vnsc-space-2: 8px;   /* sm */\r\n  --vnsc-space-3: 12px;  /* md-sm */\r\n  --vnsc-space-4: 16px;  /* md */\r\n  --vnsc-space-5: 20px;  /* md-lg */\r\n  --vnsc-space-6: 24px;  /* lg */\r\n  --vnsc-space-8: 32px;  /* xl */\r\n  --vnsc-space-10: 40px; /* 2xl */\r\n  --vnsc-space-12: 48px; /* 3xl */\r\n  --vnsc-space-16: 64px; /* 4xl */\r\n\r\n  /* Semantic spacing aliases */\r\n  --vnsc-space-xs: 4px;\r\n  --vnsc-space-sm: 8px;\r\n  --vnsc-space-md: 16px;\r\n  --vnsc-space-lg: 24px;\r\n  --vnsc-space-xl: 32px;\r\n  --vnsc-space-2xl: 40px;\r\n  --vnsc-space-3xl: 48px;\r\n\r\n  /* Component-specific spacing */\r\n  --vnsc-space-toolbar-gap: 8px;\r\n  --vnsc-space-toolbar-padding: 8px;\r\n  --vnsc-space-panel-padding: 16px;\r\n  --vnsc-space-modal-padding: 24px;\r\n  --vnsc-space-drawing-gap: 4px;\r\n  --vnsc-space-dock-padding: 12px;\r\n  --vnsc-space-splitter-size: 4px;\r\n  --vnsc-space-header-height: 36px;\r\n  --vnsc-space-footer-height: 28px;\r\n  --vnsc-space-panel-height: 300px;\r\n\r\n  /* Border Radius */\r\n  --vnsc-radius-none: 0;\r\n  --vnsc-radius-xs: 2px;\r\n  --vnsc-radius-sm: 4px;\r\n  --vnsc-radius-md: 6px;\r\n  --vnsc-radius-lg: 8px;\r\n  --vnsc-radius-xl: 12px;\r\n  --vnsc-radius-2xl: 16px;\r\n  --vnsc-radius-full: 9999px;\r\n\r\n  /* Semantic radius aliases */\r\n  --vnsc-radius-button: 4px;\r\n  --vnsc-radius-input: 4px;\r\n  --vnsc-radius-card: 8px;\r\n  --vnsc-radius-modal: 12px;\r\n  --vnsc-radius-popover: 8px;\r\n  --vnsc-radius-tooltip: 6px;\r\n\r\n  /* Sizing */\r\n  --vnsc-size-xs: 16px;\r\n  --vnsc-size-sm: 24px;\r\n  --vnsc-size-md: 32px;\r\n  --vnsc-size-lg: 40px;\r\n  --vnsc-size-xl: 48px;\r\n  --vnsc-size-2xl: 56px;\r\n  --vnsc-size-3xl: 64px;\r\n\r\n  /* Icon sizes */\r\n  --vnsc-icon-xs: 12px;\r\n  --vnsc-icon-sm: 16px;\r\n  --vnsc-icon-md: 20px;\r\n  --vnsc-icon-lg: 24px;\r\n  --vnsc-icon-xl: 28px;\r\n\r\n  /* Button sizes */\r\n  --vnsc-btn-height-sm: 24px;\r\n  --vnsc-btn-height-md: 32px;\r\n  --vnsc-btn-height-lg: 40px;\r\n  --vnsc-btn-padding-x-sm: 8px;\r\n  --vnsc-btn-padding-x-md: 12px;\r\n  --vnsc-btn-padding-x-lg: 16px;\r\n\r\n  /* Input sizes */\r\n  --vnsc-input-height-sm: 24px;\r\n  --vnsc-input-height-md: 32px;\r\n  --vnsc-input-height-lg: 40px;\r\n  --vnsc-input-padding-x: 10px;\r\n\r\n  /* Chart-specific sizes */\r\n  --vnsc-chart-margin-top: 8px;\r\n  --vnsc-chart-margin-right: 12px;\r\n  --vnsc-chart-margin-bottom: 32px;\r\n  --vnsc-chart-margin-left: 12px;\r\n  --vnsc-pane-min-height: 60px;\r\n  --vnsc-pane-handle-size: 4px;\r\n  --vnsc-tooltip-padding: 8px 12px;\r\n  --vnsc-tooltip-gap: 4px;\r\n}"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
